(function () {
    var root = document.querySelector('.jb-home26');
    if (!root) return;

    function initCarousel(vpId) {
      var vp = document.getElementById(vpId);
      if (!vp) return null;
      var track = vp.querySelector('.jbh-track');
      if (!track || !track.children.length) return null;

      function cardWidth() {
        var card = track.children[0];
        if (!card) return 0;
        var styles = getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      // Track whether the user has interacted so late centerings (image-load,
      // resize) don't yank them back to the starting position.
      var userInteracted = false;
      function markInteracted() { userInteracted = true; }
      vp.addEventListener('pointerdown', markInteracted, { passive: true });
      vp.addEventListener('wheel', markInteracted, { passive: true });
      vp.addEventListener('touchstart', markInteracted, { passive: true });

      function step(dir) {
        markInteracted();
        vp.scrollBy({ left: cardWidth() * dir, behavior: 'smooth' });
      }
      Array.prototype.forEach.call(document.querySelectorAll('[data-jbh-prev="' + vpId + '"]'), function (b) {
        b.addEventListener('click', function () { step(-1); });
      });
      Array.prototype.forEach.call(document.querySelectorAll('[data-jbh-next="' + vpId + '"]'), function (b) {
        b.addEventListener('click', function () { step(1); });
      });

      return {
        vp: vp,
        track: track,
        cardWidth: cardWidth,
        hasInteracted: function () { return userInteracted; }
      };
    }

    // ---- Infinite loop (ported from jb-bold-flavors), shared by both carousels ----
    function setupLoop(c) {
      if (!c) return;
      var vp = c.vp;
      var track = c.track;
      var cardWidth = c.cardWidth;
      var originals = Array.prototype.slice.call(track.children);
      if (originals.length < 2) return;

      // Clone slides for the loop illusion. Do NOT disable buttons in
      // clones — they submit the same variant as the originals and disabling
      // them makes the peek cards look broken when the user clicks them.
      function cloneSlide(s) {
        var cl = s.cloneNode(true);
        cl.setAttribute('aria-hidden', 'true');
        cl.classList.add('is-clone');
        Array.prototype.forEach.call(cl.querySelectorAll('a, button, input'), function (el) {
          el.setAttribute('tabindex', '-1');
        });
        return cl;
      }

      // Pad short collections before cloning. settle() treats the track as
      // exactly three sets and wraps on `mid >= 2*setW` / `mid < setW`, which
      // only stays inside the scrollable range while setW >= clientWidth/2.
      // Since cards are now capped at --jbh-card-max, a small collection on a
      // very wide screen falls under that (e.g. 4 FruitBites × 424px = 1696px
      // against a 3440px ultrawide) and the loop stops wrapping. Repeating the
      // set until it spans the viewport restores the margin and stops the
      // originals band from looking sparse. No extra network cost — the
      // duplicates reuse images already requested.
      var pads = 0;
      while (cardWidth() > 0 && cardWidth() * originals.length < vp.clientWidth && pads < 3) {
        originals.forEach(function (s) { track.appendChild(cloneSlide(s)); });
        originals = Array.prototype.slice.call(track.children);
        pads++;
      }

      originals.forEach(function (s) { track.appendChild(cloneSlide(s)); });
      originals.slice().reverse().forEach(function (s) { track.insertBefore(cloneSlide(s), track.firstChild); });

      function setW() { return cardWidth() * originals.length; }
      function trackGapPx() {
        var styles = getComputedStyle(track);
        return parseFloat(styles.columnGap || styles.gap || '0') || 0;
      }
      function leftPeek() {
        if (window.innerWidth < 700) {
          // Mobile: center one card with symmetric small peek on each side.
          return (vp.clientWidth - cardWidth() + trackGapPx()) / 2;
        }
        // Tablet / Desktop: half-card peek.
        return cardWidth() * 0.5;
      }
      function center() {
        var prevBehavior = vp.style.scrollBehavior;
        vp.style.scrollBehavior = 'auto';
        vp.scrollLeft = setW() - leftPeek();
        void vp.offsetWidth;
        vp.style.scrollBehavior = prevBehavior;
      }
      function safeCenter() {
        if (c.hasInteracted()) return;
        center();
      }

      // Center as early as possible to avoid a visible scroll-in on load.
      center();
      requestAnimationFrame(center);
      window.addEventListener('load', function () { requestAnimationFrame(safeCenter); }, { once: true });

      // Re-center if an image loads late and shifts widths, but ONLY if the
      // user hasn't started interacting with the carousel yet.
      Array.prototype.forEach.call(track.querySelectorAll('li:not(.is-clone) img'), function (img) {
        if (!img.complete) img.addEventListener('load', safeCenter, { once: true });
      });

      // After scrolling stops: (1) jump back into the originals set if the
      // user drifted into a clone region, (2) align the nearest card to the
      // center (JS snapping — CSS scroll-snap would fight the loop jumps).
      var touchActive = false;
      vp.addEventListener('touchstart', function () { touchActive = true; }, { passive: true });
      vp.addEventListener('touchend', function () { touchActive = false; queueSettle(); }, { passive: true });

      function settle() {
        var sw = setW();
        if (sw === 0) return;
        var sl = vp.scrollLeft;
        var mid = sl + vp.clientWidth / 2;
        if (mid >= 2 * sw) {
          vp.style.scrollBehavior = 'auto';
          sl = sl - sw;
          vp.scrollLeft = sl;
          void vp.offsetWidth;
          vp.style.scrollBehavior = '';
        } else if (mid < sw) {
          vp.style.scrollBehavior = 'auto';
          sl = sl + sw;
          vp.scrollLeft = sl;
          void vp.offsetWidth;
          vp.style.scrollBehavior = '';
        }
        if (touchActive) return;
        var cw = cardWidth();
        if (!cw) return;
        var base = sw - leftPeek();
        var off = (sl - base) % cw;
        if (off < 0) off += cw;
        var delta = off > cw / 2 ? cw - off : -off;
        if (Math.abs(delta) > 2) {
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          vp.scrollTo({ left: sl + delta, behavior: reduce ? 'auto' : 'smooth' });
        }
      }
      var t;
      function queueSettle() {
        clearTimeout(t);
        t = setTimeout(settle, 140);
      }
      vp.addEventListener('scroll', queueSettle, { passive: true });
    }

    setupLoop(initCarousel('jbh-flavors-vp'));
    setupLoop(initCarousel('jbh-sets-vp'));
    setupLoop(initCarousel('jbh-zubehoer-vp'));
    setupLoop(initCarousel('jbh-fruitbites-vp'));
    // Videos: plain stepping, no loop (cloning <video> elements would double
    // the media requests).
    initCarousel('jbh-videos-vp');

    // ---- Testimonials: tab switching ----
    var tabs = root.querySelectorAll('.jbh-tab-btn');
    var reviewItems = root.querySelectorAll('.jbh-review');
    Array.prototype.forEach.call(tabs, function (tab) {
      tab.addEventListener('click', function () {
        var category = this.getAttribute('data-jbh-category');
        Array.prototype.forEach.call(tabs, function (t) {
          t.classList.toggle('jbh-tab-active', t.getAttribute('data-jbh-category') === category);
        });
        Array.prototype.forEach.call(reviewItems, function (review) {
          if (review.getAttribute('data-jbh-cat') === category) {
            review.removeAttribute('data-hidden');
          } else {
            review.setAttribute('data-hidden', 'true');
          }
        });
      });
    });

    // ---- Testimonials: lazy thumbnail loading ----
    // Videos start with preload="none" (zero cost at page load); when the
    // video strip approaches the viewport, upgrade to metadata so the
    // first-frame thumbnails render before the visitor arrives.
    (function () {
      var videosVp = document.getElementById('jbh-videos-vp');
      if (!videosVp) return;
      function warmVideos() {
        Array.prototype.forEach.call(videosVp.querySelectorAll('video[preload="none"]'), function (v) {
          v.preload = 'metadata';
          v.load();
        });
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) {
            warmVideos();
            io.disconnect();
          }
        }, { rootMargin: '600px 0px' });
        io.observe(videosVp);
      } else {
        warmVideos();
      }
    })();

    // ---- Testimonials: video play/pause ----
    var videoCards = root.querySelectorAll('.jbh-video-card');
    var currentlyPlaying = null;
    Array.prototype.forEach.call(videoCards, function (card) {
      card.addEventListener('click', function () {
        var video = this.querySelector('video');
        if (!video) return;
        if (currentlyPlaying && currentlyPlaying !== video) {
          currentlyPlaying.pause();
          currentlyPlaying.parentElement.classList.remove('jbh-playing');
        }
        if (video.paused) {
          video.play();
          this.classList.add('jbh-playing');
          currentlyPlaying = video;
        } else {
          video.pause();
          this.classList.remove('jbh-playing');
          currentlyPlaying = null;
        }
      });
    });
  })();
